import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService, MgApplicationUser } from 'src/app/core/services/auth.service';
import { ChangePassTempComponent } from 'src/app/system-setting/users/change-pass-temp/change-pass-temp.component';

@Component({
  selector: 'mg-account-dropdown',
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, NgbDropdownModule,],
  providers: [ChangePassTempComponent]
})
export class AccountDropdownComponent {
  @Input() light: boolean;

  acc: MgApplicationUser | null = null;
  constructor( private router: Router, private authService: AuthenticationService) {
    this.authService.identity().subscribe(acc => {
      this.acc = acc;
    })
  }


  modal = inject(NgbModal);
  openChangePassFormModal() {

    if (this.acc) {
      const modal = this.modal.open(ChangePassTempComponent, {
        modalDialogClass: 'max-w-800px',
        size: 'xl'
      });
      modal.componentInstance._setUser = this.acc;
    }
  }

  
  /**
   * Logout the user
   */
  logout() {

    this.authService.logout();
    this.router.navigate(['/account/login']);
  }
}
